import {
  AtsJobRequisitionsListDocument,
  CreateRequisitionDocument,
  CreateRequisitionMutation,
  CreateRequisitionMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export type CreateRequisitionPayload =
  CreateRequisitionMutation['atsMutations']['createAtsRequisition']

export type AtsRequisition = CreateRequisitionPayload['requisition']

export const useCreateRequisition = () => {
  const [createRequisition, { loading }] = useMutation(CreateRequisitionDocument, {
    extractorFn: (data: CreateRequisitionMutation) => data.atsMutations.createAtsRequisition,
  })

  return {
    loading,
    create(variables: CreateRequisitionMutationVariables) {
      return createRequisition({
        variables,
        refetchQueries: [AtsJobRequisitionsListDocument],
      })
    },
  }
}
